import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { USER } from "constants/AuthConstant";
import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";

export const getUnitList = createAsyncThunk("units/getUnitList", async (filters, { rejectWithValue }) => {
	try {
		const user_channel = PermissionManager.getItem(USER)?.user?.user_channel[0]?.channel_uuid;
		const response = await axiosHttp.get(`channel/${user_channel}/unit`);
		return response.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || "An error occurred");
	}
});

// Initial state
const initialState = {
	units: [],
	isLoading: false,
	error: null,
};

// Redux slice
const UnitListSlice = createSlice({
	name: "units",
	initialState,
	reducers: {
		resetUnitListState: (state) => {
			return {
				units: [],
				isLoading: false,
				error: null,
			};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getUnitList.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(getUnitList.fulfilled, (state, action) => {
				state.isLoading = false;
				state.units = action.payload;
			})
			.addCase(getUnitList.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || "Failed to fetch units.";
			});
	},
});

export const { resetUnitListState } = UnitListSlice.actions;
export default UnitListSlice.reducer;
